module.exports = __webpack_public_path__ + "img/sign-up.e7a32748.png";